'use strict';
(function($){
	/*
	 * Vetology.GTranslate widget
	 *
	 * @description This ios the main Vetology widget to load the tools needed in the page
	 *				By the time this plugin runs, all othrs should have already been loaded, so this should be the last script to be loaded;
	 *
	 * @options					See description for each option
	 *
	 * @method	See description above each method
	 */
	$.widget(
		'Vetology.GTranslate',
		{
			"options": {
				"src": "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit",
				"element": "google_translate_element",
			},
			/*
			 * Vetology.Vetology._init
			 *
			 * @description	Initializes the Vetology Platform
			 *
			 * @return NULL
			 *
			 */
			"_init": function(){
				var o = this;
				if($("#" + o.options.element).length > 0){
					$.getScript(o.options.src + o.options.element, function(data, textStatus, jqxhr){
						var interval = setInterval(function(){
							if(typeof google != "undefined" && typeof google.translate != "undefined" && typeof google.translate.TranslateElement != "undefined"){
								clearInterval(interval);
								var translator = new google.translate.TranslateElement(
									{
										pageLanguage: 'en',
										done: function(){
										},
										complete: function(){
										},
										ready: function(){
										},
									},
									'google_translate_element'
								);
								interval = setInterval(function(){
									if(typeof translator.c !== "undefined"){
										clearInterval(interval);
										$(".lang_ul").find('a[data-value="' + translator.c + '"]').closest("li").addClass("active");
										$(".lang_ul a").on("click", function(e){
											e.preventDefault();
											$(".lang_ul li").removeClass("active");
											var el = $(this);
											el.closest("li").addClass("active");
											$(".goog-te-combo").val(el.data("value"));
											$("body").Vetology("triggerHtmlEvent", $(".goog-te-combo")[0], "change");
										});
									}
								}, 100);
							}
						}, 100);
					});
				}
			}
		}
	);
})(jQuery);
